import React, { useState, useEffect } from 'react';
import CoachLayout from './CoachLayout';

export default function CapstoneSubmissionsPage() {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('coach_token') || localStorage.getItem('scenario_os_token');
    fetch('/scenario-os/curriculum/capstone/submissions?status=coach_review_pending', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(data => {
        setSubmissions(data.submissions || []);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load submissions');
        setLoading(false);
      });
  }, []);

  const handleApprove = async (submissionId, feedback) => {
    const token = localStorage.getItem('coach_token') || localStorage.getItem('scenario_os_token');
    const res = await fetch(`/scenario-os/curriculum/capstone/${submissionId}/approve`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ coach_feedback: feedback }),
    });
    if (res.ok) {
      setSubmissions(prev => prev.filter(s => s.submission_id !== submissionId));
    }
  };

  const handleRequestResubmit = async (submissionId, note) => {
    const token = localStorage.getItem('coach_token') || localStorage.getItem('scenario_os_token');
    const res = await fetch(`/scenario-os/curriculum/capstone/${submissionId}/request-resubmit`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ coach_note: note }),
    });
    if (res.ok) {
      setSubmissions(prev => prev.filter(s => s.submission_id !== submissionId));
    }
  };

  const body = () => {
    if (loading) return <div style={{ padding: 24 }}>Loading submissions...</div>;
    if (error) return <div style={{ padding: 24, color: 'red' }}>{error}</div>;
    return (
      <div style={{ padding: 24 }}>
        <h2>Capstone Submissions — Pending Review</h2>
        {submissions.length === 0 ? (
          <p style={{ color: '#666' }}>No submissions pending review.</p>
        ) : (
          submissions.map(sub => (
            <SubmissionCard
              key={sub.submission_id}
              submission={sub}
              onApprove={handleApprove}
              onRequestResubmit={handleRequestResubmit}
            />
          ))
        )}
      </div>
    );
  };

  return <CoachLayout title="Capstone Reviews">{body()}</CoachLayout>;
}

function SubmissionCard({ submission, onApprove, onRequestResubmit }) {
  const [feedback, setFeedback] = useState('');
  const [expanded, setExpanded] = useState(false);

  return (
    <div style={{
      border: '1px solid #ddd', borderRadius: 8, padding: 16,
      marginBottom: 16, background: '#fff',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <strong>{submission.learner_id}</strong> — {submission.domain || 'Unknown domain'}
          <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>
            Submitted: {submission.submitted_at ? new Date(submission.submitted_at).toLocaleDateString() : 'Unknown'}
            {' | '}
            AI Score: {submission.ai_overall_pct != null ? `${submission.ai_overall_pct.toFixed(0)}%` : 'Pending'}
          </div>
        </div>
        <button onClick={() => setExpanded(e => !e)} style={{ fontSize: 12 }}>
          {expanded ? 'Collapse' : 'Review'}
        </button>
      </div>

      {expanded && (
        <div style={{ marginTop: 12 }}>
          <h4 style={{ marginBottom: 8 }}>Submission</h4>
          <p style={{ whiteSpace: 'pre-wrap', background: '#f9f9f9', padding: 12, borderRadius: 4 }}>
            {submission.text}
          </p>
          {submission.ai_feedback && (
            <>
              <h4 style={{ marginTop: 12, marginBottom: 8 }}>AI Feedback</h4>
              <p style={{ whiteSpace: 'pre-wrap', background: '#f0f7ff', padding: 12, borderRadius: 4 }}>
                {typeof submission.ai_feedback === 'string'
                  ? submission.ai_feedback
                  : JSON.stringify(submission.ai_feedback, null, 2)}
              </p>
            </>
          )}
          <h4 style={{ marginTop: 12, marginBottom: 8 }}>Your Feedback (optional)</h4>
          <textarea
            value={feedback}
            onChange={e => setFeedback(e.target.value)}
            rows={4}
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
            placeholder="Add your coaching feedback..."
          />
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <button
              onClick={() => onApprove(submission.submission_id, feedback)}
              style={{
                background: '#2ecc71', color: '#fff', border: 'none',
                borderRadius: 4, padding: '8px 16px', cursor: 'pointer',
              }}
            >
              Approve
            </button>
            <button
              onClick={() => onRequestResubmit(submission.submission_id, feedback || 'Please revise and resubmit.')}
              style={{
                background: '#e74c3c', color: '#fff', border: 'none',
                borderRadius: 4, padding: '8px 16px', cursor: 'pointer',
              }}
            >
              Request Resubmission
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
